// extracted by mini-css-extract-plugin
module.exports = {"container":"NoNewNotifications_container__1G-qW"};